import { debounce } from '@repo/utils';
import { useEffect, useState } from 'react';
import { MOBILE_BREAKPOINT } from '../constants/breakpoints';

/**
 * Detects if the current viewport is mobile-sized based on window width.
 * Returns a boolean that updates on window resize events.
 */
interface UseMobileDetectionOptions {
  breakpoint?: number;
}

export const useMobileDetection = (options: UseMobileDetectionOptions = {}) => {
  const { breakpoint = MOBILE_BREAKPOINT } = options;

  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth <= breakpoint;
  });

  useEffect(() => {
    let isMounted = true;

    const checkIsMobile = () => {
      if (!isMounted) return;
      setIsMobile(window.innerWidth <= breakpoint);
    };

    const debouncedCheckIsMobile = debounce(checkIsMobile, 100);

    window.addEventListener('resize', debouncedCheckIsMobile);
    return () => {
      isMounted = false;
      window.removeEventListener('resize', debouncedCheckIsMobile);
    };
  }, [breakpoint]);

  return { isMobile };
};
